var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * @file This file is to arrange logan operations in queue, in order to avoid parallel async writing operations on db which may cause race condition problems.
 *
 * 由于Logan的log方法涉及LoganDB日志存储空间大小的改写、report方法在做增量上报时涉及本地日志数据的删除，这些方法被异步执行时可能会发生竞态条件导致DB内数据不准确，进而导致已存储的日志大小远超过存储空间限制、在触发上报时段写入的日志被删除这类问题，因此Logan需要内部维护该执行列表，确保这些异步方法按序一一执行。
 *
 */
var loganOperationQueue = [];
var operationRunning = false;
function loganOperationsRecursion() {
    return __awaiter(this, void 0, void 0, function () {
        var nextOperation, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(loganOperationQueue.length > 0 && !operationRunning)) return [3 /*break*/, 5];
                    nextOperation = loganOperationQueue.shift();
                    operationRunning = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, nextOperation.asyncF()];
                case 2:
                    result = _a.sent();
                    nextOperation.resolution(result);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    nextOperation.rejection(e_1);
                    return [3 /*break*/, 4];
                case 4:
                    operationRunning = false; /* eslint-disable-line */ // No need to worry require-atomic-updates here.
                    loganOperationsRecursion();
                    return [3 /*break*/, 0];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function invokeInQueue(asyncF) {
    return new Promise(function (resolve, reject) {
        loganOperationQueue.push({
            asyncF: asyncF,
            resolution: resolve,
            rejection: reject
        });
        loganOperationsRecursion();
    });
}
